import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'
import { getFinalDiscountExplained } from './helpers.js'

let MOCKED_PAYMENT_PLANS = [
  {
    name: 'Best for smallest total',
    downpayment: 100,
    downpayment_type: 'percentage',
    frequency: 'None',
    discounts: [
      {
        value: 10,
        type: 'percentage',
        stack: true,
      },
    ],
  },
  {
    name: 'Option #1 - Paid in Full',
    downpayment: 100,
    downpayment_type: 'percentage',
    frequency: 'None',
    discounts: [
      {
        value: 100,
        type: 'amount',
        stack: true,
      },
    ],
  },
  {
    name: 'Option #2 - $1000 Down',
    downpayment: 500,
    downpayment_type: 'amount',
    frequency: 'Monthly',
    discounts: [
      {
        value: 5,
        type: 'percentage',
        stack: false,
      },
    ],
  },
  {
    name: 'Option #3 - $750 Down',
    downpayment: 750,
    downpayment_type: 'amount',
    frequency: 'Monthly',
    discounts: [
      {
        value: 200,
        type: 'amount',
        stack: false,
      },
    ],
  },
  {
    name: 'Option #4 - $500 Down',
    downpayment: 500,
    downpayment_type: 'amount',
    frequency: 'EverySecondWeek',
    discounts: [],
  },
]

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let show_mocked_plans = useDataValue({
    context: 'setup',
    path: 'show_mocked_plans',
    viewPath: props.viewPath,
  })
  let payor_share = useDataValue({
    context: 'setup',
    path: 'payor_share',
    viewPath: props.viewPath,
  })
  let payor_discounts = useDataValue({
    context: 'setup',
    path: 'payor_discounts',
    viewPath: props.viewPath,
  })
  let treatment_discounts = useDataValue({
    context: 'setup',
    path: 'treatment_discounts',
    viewPath: props.viewPath,
  })
  let max_discount = useDataValue({
    context: 'setup',
    path: 'max_discount',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    let paymentPlans

    if (!data?.length) {
      if (!show_mocked_plans) {
        return data
      } else {
        paymentPlans = MOCKED_PAYMENT_PLANS
      }
    } else {
      paymentPlans = data
    }

    return paymentPlans.map(item => {
      let calculatedDiscount = getFinalDiscountExplained({
        payor_discounts,
        treatment_discounts,
        payor_share,
        max_discount,
        payment_plan_discount: item.discounts[0] ?? null,
      })

      return {
        ...item,
        ...calculatedDiscount,
        total_to_pay: payor_share - calculatedDiscount.final_discount.amount,
      }
    })
  }, [
    data,
    show_mocked_plans,
    payor_share,
    payor_discounts,
    treatment_discounts,
    max_discount,
  ])
}
